/* global Blockly */
import React, { Component } from 'react';

class Today extends Component {
    static blockName = "date_today";

    constructor(props) {
        super(props);

        Blockly.Blocks[this.constructor.blockName] = this.block();

        let generators = this.generators();
        for (let i in generators) {
            Blockly[i][this.constructor.blockName] = generators[i];
        }
    }

    block() {
        return {
            init:function() {
                this.appendDummyInput()
                //     .appendField(new Blockly.FieldDropdown([['am','AM'],['pm','PM']]))
                    .appendField("today");
                // Provide values for all of these
                this.setPreviousStatement(false);
                this.setNextStatement(false);
                this.setOutput(true,"Date"); // add appropriate checks
                this.setOutputShape(Blockly.OUTPUT_SHAPE_ROUND);
                this.setColour(Blockly.Msg.DATES_HUE);
                this.setTooltip('Get today\'s date');
                this.setHelpUrl(Blockly.BASE_HELP_URL+'#dates');
            }
        }
    }

    generators() {
        return {
            'JavaScript': function () {
                let code = '(new Date())';
                return [code, Blockly.JavaScript.ORDER_NONE]
            }
        }
    }

    // Should return null if block shouldn't appear in toolbox
    render() {
        return (
            <block type={this.constructor.blockName}>{/* NOSONAR */}
                <value name="HOUR"><shadow type="math_whole_number"><field name="NUM">12</field></shadow></value>{/* NOSONAR */}
                <value name="MINUTE"><shadow type="math_whole_number"><field name="NUM">00</field></shadow></value>{/* NOSONAR */}
            </block>
        );
    }
}

export default Today;